const googleDocsRegex =
  /https:\/\/docs\.google\.com\/(document|spreadsheets|presentation|forms)\/d\/([a-zA-Z0-9_-]+)/;
const googleDriveRegex =
  /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
const oneDriveRegex =
  /https:\/\/[a-zA-Z0-9\-]+\.sharepoint\.com\/.*\/([a-zA-Z0-9_-]+)(?=\?)/;

export function getDocumentId(url) {
  let documentId = null;

  if (googleDocsRegex.test(url)) {
    const match = url.match(googleDocsRegex);
    documentId = match[2]; // Extract document ID from Google Docs URL
  }

  if (googleDriveRegex.test(url)) {
    const match = url.match(googleDriveRegex);
    documentId = match[1]; // Extract file ID from Google Drive URL
  }

  if (oneDriveRegex.test(url)) {
    const match = url.match(oneDriveRegex);
    documentId = match[1]; // Extract file ID from OneDrive URL
  }

  return documentId || "";
}

export function isDocumentValid(url) {
  return (
    googleDocsRegex.test(url) ||
    googleDriveRegex.test(url) ||
    oneDriveRegex.test(url)
  );
}

// Placeholder/prompt copy for the Embed-URL input, keyed by the block's media
// `type`. Media blocks pass both singular ("image"/"document") and plural
// ("images"/"documents") forms, so every branch must match both spellings.
// (Previously written as `case "image" || "images"`, which JS evaluates to
// `case "image"` — so the plural "images"/"documents" types silently fell
// through to the generic default copy.)
export function getEmbedPlaceholderText(type) {
  switch (type) {
    case "image":
    case "images":
      return "Put an image URL below to upload your image directly!";
    case "video":
      return "Put a video URL below to upload your video directly!";
    case "wheel":
      return "Paste a wheel link below (e.g. https://web.iyuga.net/wheel/123) to link it in this segment.";
    case "document":
    case "documents":
      return "Put a google docs URL below to upload your document directly!";
    default:
      return "Put a URL below to upload your media directly!";
  }
}